"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[79956],{

/***/ 79956:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Layout_Footer; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/makeStyles.js
var makeStyles = __webpack_require__(41120);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/createStyles.js + 1 modules
var createStyles = __webpack_require__(75154);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Container/Container.js
var Container = __webpack_require__(43832);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Grid/Grid.js
var Grid = __webpack_require__(41749);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Typography/Typography.js
var Typography = __webpack_require__(22318);
// EXTERNAL MODULE: ./components/Button/Button.tsx
var Button = __webpack_require__(41107);
// EXTERNAL MODULE: ./components/Link/Link.tsx
var Link = __webpack_require__(31520);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/@datapunt/matomo-tracker-react/es/useMatomo.js + 1 modules
var useMatomo = __webpack_require__(86700);
// EXTERNAL MODULE: ./components/Global/CMSText.tsx
var CMSText = __webpack_require__(94455);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Dialog/Dialog.js
var Dialog = __webpack_require__(52663);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/FormControl/FormControl.js
var FormControl = __webpack_require__(64436);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/RadioGroup/RadioGroup.js + 1 modules
var RadioGroup = __webpack_require__(37661);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/FormControlLabel/FormControlLabel.js
var FormControlLabel = __webpack_require__(30553);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Radio/Radio.js + 4 modules
var Radio = __webpack_require__(32340);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/CircularProgress/CircularProgress.js
var CircularProgress = __webpack_require__(95477);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/Close.js
var Close = __webpack_require__(80366);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/CheckCircleOutline.js
var CheckCircleOutline = __webpack_require__(23059);
// EXTERNAL MODULE: ./components/TextField/TextField.tsx + 1 modules
var TextField = __webpack_require__(59000);
// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__(9669);
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/path-browserify/index.js
var path_browserify = __webpack_require__(1864);
var path_browserify_default = /*#__PURE__*/__webpack_require__.n(path_browserify);
// EXTERNAL MODULE: ./redux/helpers/api.ts + 1 modules
var api = __webpack_require__(12664);
// EXTERNAL MODULE: ./redux/helpers/requests.ts
var requests = __webpack_require__(20031);
;// CONCATENATED MODULE: ./redux/services/contactRequests.ts




function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var RMS_API = "https://api-staging.lizee.io" || 0;
var RMS_PUBLIC_API_TOKEN = "pCiqzNuJxd3BLGSwa2ohRqsxB2k6GD9B" || 0;
/**
 * The contact-requests endpoint expects a locale like "fr-fr", whereas
 * `getLocale()` returns the Sylius format ("fr_FR"). Normalise it here.
 */ var toContactRequestLocale = function(customLocale) {
    return (0,api/* getLocale */.Kd)(customLocale).replace('_', '-').toLowerCase();
};
var contactRequestsUrl = function() {
    var baseUrl = RMS_API.endsWith('/api') ? "".concat(RMS_API, "/") : "".concat(RMS_API, "/api/");
    return "".concat(baseUrl).concat(path_browserify_default().join(requests/* RMSRequestUrl.contactRequests */.jo.contactRequests, ''));
};
/**
 * Creates a public "retraction / cancellation" contact request on the RMS.
 * Identified by the store's public app token (x-api-key), so no login needed.
 */ var createContactRequest = function(payload) {
    return axios_default()({
        method: 'POST',
        url: contactRequestsUrl(),
        headers: {
            'Content-Type': 'application/json',
            'x-api-key': RMS_PUBLIC_API_TOKEN
        },
        data: _objectSpread({
            orderReference: payload.orderReference,
            email: payload.email,
            type: payload.type
        }, payload.message ? {
            message: payload.message
        } : {}, {
            locale: toContactRequestLocale()
        })
    }).then(function(res) {
        return res.data;
    });
};

;// CONCATENATED MODULE: ./components/ContactRequest/CancelContractModal.tsx











function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
var EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
var useStyles = (0,makeStyles/* default */.Z)(function(theme) {
    var ref;
    return (0,createStyles/* default */.Z)({
        modal: {
            '& .MuiDialog-paper': {
                width: '100%',
                maxWidth: 520
            }
        },
        head: {
            display: 'flex',
            alignItems: 'flex-start',
            justifyContent: 'space-between',
            padding: theme.spacing(3, 3, 1, 3)
        },
        title: {
            fontWeight: 500,
            color: theme.palette.primary.main
        },
        close: {
            cursor: 'pointer',
            marginLeft: theme.spacing(2),
            flexShrink: 0
        },
        content: {
            padding: theme.spacing(1, 3, 3, 3)
        },
        intro: {
            marginBottom: theme.spacing(2)
        },
        typeGroup: {
            marginBottom: theme.spacing(2)
        },
        typeLabel: {
            marginBottom: theme.spacing(0.5)
        },
        messageField: {
            '& .input': {
                width: '100%'
            },
            '& .MuiInputBase-root': {
                width: '100%'
            },
            '& .MuiInputBase-input, & textarea': {
                width: '100%',
                boxSizing: 'border-box'
            }
        },
        error: {
            color: theme.palette.error.main,
            marginTop: theme.spacing(-1),
            marginBottom: theme.spacing(1.5),
            fontSize: '0.8rem'
        },
        globalError: {
            color: theme.palette.error.main,
            marginTop: theme.spacing(1)
        },
        required: {
            display: 'block',
            marginTop: theme.spacing(1),
            color: theme.palette.text.secondary,
            fontSize: '0.8rem'
        },
        submit: {
            marginTop: theme.spacing(3)
        },
        success: {
            textAlign: 'center',
            padding: theme.spacing(4, 3)
        },
        successIcon: {
            fontSize: 64,
            color: ((ref = theme.palette.success) === null || ref === void 0 ? void 0 : ref.main) || theme.palette.primary.main,
            marginBottom: theme.spacing(2)
        }
    });
});
var CancelContractModal = function(param) {
    var open = param.open, onClose = param.onClose, doc = param.doc, t = param.t;
    var classes = useStyles();
    var data = doc === null || doc === void 0 ? void 0 : doc.data;
    var ref = (0,react.useState)('CANCELLATION'), type = ref[0], setType = ref[1];
    var ref1 = (0,react.useState)(''), orderReference = ref1[0], setOrderReference = ref1[1];
    var ref2 = (0,react.useState)(''), email = ref2[0], setEmail = ref2[1];
    var ref3 = (0,react.useState)(''), message = ref3[0], setMessage = ref3[1];
    var ref4 = (0,react.useState)({}), errors = ref4[0], setErrors = ref4[1];
    var ref5 = (0,react.useState)(false), isSubmitting = ref5[0], setIsSubmitting = ref5[1];
    var ref6 = (0,react.useState)(false), isSuccess = ref6[0], setIsSuccess = ref6[1];
    var resetAndClose = function() {
        onClose();
        // Reset once the modal is closed so the user does not see it flicker.
        setTimeout(function() {
            setType('CANCELLATION');
            setOrderReference('');
            setEmail('');
            setMessage('');
            setErrors({});
            setIsSuccess(false);
        }, 300);
    };
    var validate = function() {
        var nextErrors = {};
        if (!orderReference.trim()) {
            nextErrors.orderReference = t('texts:cancel_contract:error_order_reference');
        }
        if (!email.trim() || !EMAIL_REGEX.test(email.trim())) {
            nextErrors.email = t('texts:cancel_contract:error_email');
        }
        setErrors(nextErrors);
        return Object.keys(nextErrors).length === 0;
    };
    var handleSubmit = function() {
        var _ref = _asyncToGenerator(runtime_default().mark(function _callee(e) {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        e.preventDefault();
                        if (!isSubmitting) {
                            _ctx.next = 3;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 3:
                        if (validate()) {
                            _ctx.next = 5;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 5:
                        setIsSubmitting(true);
                        setErrors({});
                        _ctx.prev = 7;
                        _ctx.next = 10;
                        return createContactRequest({
                            orderReference: orderReference.trim(),
                            email: email.trim(),
                            type: type,
                            message: message.trim() || undefined
                        });
                    case 10:
                        setIsSuccess(true);
                        _ctx.next = 16;
                        break;
                    case 13:
                        _ctx.prev = 13;
                        _ctx.t0 = _ctx["catch"](7);
                        setErrors({
                            global: t('texts:cancel_contract:error_generic')
                        });
                    case 16:
                        _ctx.prev = 16;
                        setIsSubmitting(false);
                        return _ctx.finish(16);
                    case 19:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    7,
                    13,
                    16,
                    19
                ]
            ]);
        }));
        return function handleSubmit(e) {
            return _ref.apply(this, arguments);
        };
    }();
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(Dialog/* default */.Z, {
        className: (0,clsx_m/* default */.Z)('cancel-contract-modal', classes.modal),
        open: open,
        onClose: resetAndClose,
        maxWidth: "sm",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (0,clsx_m/* default */.Z)('cancel-contract-modal__head', classes.head),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        variant: "h5",
                        component: "h2",
                        className: classes.title,
                        children: (0,CMSText/* prismicText */.yz)(data === null || data === void 0 ? void 0 : data.cancel_contract_title, t('texts:cancel_contract:title'))
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Close/* default */.Z, {
                        className: (0,clsx_m/* default */.Z)('cancel-contract-modal__close', classes.close),
                        onClick: resetAndClose,
                        role: "button",
                        "aria-label": t('texts:cancel_contract:close_button')
                    })
                ]
            }),
            isSuccess ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (0,clsx_m/* default */.Z)('cancel-contract-modal__success', classes.success),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckCircleOutline/* default */.Z, {
                        className: classes.successIcon
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        variant: "h6",
                        component: "p",
                        gutterBottom: true,
                        children: (0,CMSText/* prismicText */.yz)(data === null || data === void 0 ? void 0 : data.cancel_contract_success_title, t('texts:cancel_contract:success_title'))
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        component: "p",
                        children: (0,CMSText/* prismicText */.yz)(data === null || data === void 0 ? void 0 : data.cancel_contract_success_message, t('texts:cancel_contract:success_message'))
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        variant: "contained",
                        color: "primary",
                        className: classes.submit,
                        onClick: resetAndClose,
                        children: (0,CMSText/* prismicText */.yz)(data === null || data === void 0 ? void 0 : data.cancel_contract_close_button, t('texts:cancel_contract:close_button'))
                    })
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                className: (0,clsx_m/* default */.Z)('cancel-contract-modal__content', classes.content),
                onSubmit: handleSubmit,
                noValidate: true,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        component: "p",
                        className: classes.intro,
                        children: (0,CMSText/* prismicText */.yz)(data === null || data === void 0 ? void 0 : data.cancel_contract_intro, t('texts:cancel_contract:intro'))
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(FormControl/* default */.Z, {
                        component: "fieldset",
                        className: classes.typeGroup,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                component: "legend",
                                variant: "subtitle2",
                                className: classes.typeLabel,
                                children: (0,CMSText/* prismicText */.yz)(data === null || data === void 0 ? void 0 : data.cancel_contract_type_label, t('texts:cancel_contract:type_label'))
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(RadioGroup/* default */.Z, {
                                "aria-label": "contact-request-type",
                                name: "contact-request-type",
                                value: type,
                                onChange: function(e) {
                                    return setType(e.target.value);
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FormControlLabel/* default */.Z, {
                                        value: "CANCELLATION",
                                        control: /*#__PURE__*/ (0,jsx_runtime.jsx)(Radio/* default */.Z, {
                                            color: "primary"
                                        }),
                                        label: (0,CMSText/* prismicText */.yz)(data === null || data === void 0 ? void 0 : data.cancel_contract_type_cancellation, t('texts:cancel_contract:type_cancellation'))
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FormControlLabel/* default */.Z, {
                                        value: "RETURN",
                                        control: /*#__PURE__*/ (0,jsx_runtime.jsx)(Radio/* default */.Z, {
                                            color: "primary"
                                        }),
                                        label: (0,CMSText/* prismicText */.yz)(data === null || data === void 0 ? void 0 : data.cancel_contract_type_return, t('texts:cancel_contract:type_return'))
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, {
                        name: "cancel-contract-order-reference",
                        type: "text",
                        label: (0,CMSText/* prismicText */.yz)(data === null || data === void 0 ? void 0 : data.cancel_contract_order_reference_label, t('texts:cancel_contract:order_reference_label')),
                        value: orderReference,
                        onChange: function(value) {
                            return setOrderReference(value);
                        },
                        required: true,
                        maxLength: 255
                    }),
                    errors.orderReference && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        component: "span",
                        className: classes.error,
                        children: errors.orderReference
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, {
                        name: "cancel-contract-email",
                        type: "email",
                        label: (0,CMSText/* prismicText */.yz)(data === null || data === void 0 ? void 0 : data.cancel_contract_email_label, t('texts:cancel_contract:email_label')),
                        value: email,
                        onChange: function(value) {
                            return setEmail(value);
                        },
                        required: true,
                        maxLength: 255
                    }),
                    errors.email && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        component: "span",
                        className: classes.error,
                        children: errors.email
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, {
                        className: classes.messageField,
                        name: "cancel-contract-message",
                        label: (0,CMSText/* prismicText */.yz)(data === null || data === void 0 ? void 0 : data.cancel_contract_message_label, t('texts:cancel_contract:message_label')),
                        value: message,
                        onChange: function(value) {
                            return setMessage(value);
                        },
                        textArea: true,
                        multiline: true,
                        rows: 3,
                        maxLength: 5000
                    }),
                    errors.global && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        className: classes.globalError,
                        children: errors.global
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        component: "span",
                        className: classes.required,
                        children: t('texts:cancel_contract:required_fields')
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        type: "submit",
                        variant: "contained",
                        color: "primary",
                        fullWidth: true,
                        className: (0,clsx_m/* default */.Z)('cancel-contract-modal__submit', classes.submit),
                        disabled: isSubmitting,
                        children: isSubmitting ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CircularProgress/* default */.Z, {
                            size: 22,
                            color: "inherit"
                        }) : (0,CMSText/* prismicText */.yz)(data === null || data === void 0 ? void 0 : data.cancel_contract_submit_button, t('texts:cancel_contract:submit_button'))
                    })
                ]
            })
        ]
    }));
};
/* harmony default export */ var ContactRequest_CancelContractModal = (CancelContractModal);

;// CONCATENATED MODULE: ./components/Layout/Footer.tsx










function Footer_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
var Footer_useStyles = (0,makeStyles/* default */.Z)(function(theme) {
    var _obj;
    return (0,createStyles/* default */.Z)({
        root: {
            position: 'relative',
            zIndex: 1
        },
        isBG: {
            paddingTop: theme.sizes.footerBG,
            background: "url() repeat-x 0 0",
            backgroundSize: "auto ".concat(theme.sizes.footerBG, "px"),
            '&::before': {
                content: "''",
                position: 'absolute',
                top: 0,
                left: 0,
                right: 0,
                height: theme.sizes.footerBG,
                background: 'linear-gradient(0deg, #E8E4DF 19%, rgba(232, 228, 223, 0) 50%, rgba(232, 228, 223, 0) 100%)'
            }
        },
        top: (_obj = {
            position: 'relative',
            zIndex: 2,
            borderRadius: 0,
            paddingTop: 30,
            paddingBottom: 35,
            background: theme.extraColors.greyLight,
            textAlign: 'center'
        }, Footer_defineProperty(_obj, theme.breakpoints.up('lg'), {
            textAlign: 'left'
        }), Footer_defineProperty(_obj, '&>.MuiContainer-root &>.hero__title', {
            marginBottom: theme.spacing(4)
        }), _obj),
        topRight: Footer_defineProperty({}, theme.breakpoints.up('lg'), {
            textAlign: 'right'
        }),
        topTitle: {
            fontWeight: 400,
            color: theme.palette.primary.main
        },
        topBtn: Footer_defineProperty({
            marginTop: 20
        }, theme.breakpoints.up('lg'), {
            marginTop: 0
        }),
        bottom: Footer_defineProperty({
            position: 'relative',
            zIndex: 1,
            marginTop: -8,
            paddingTop: 54,
            paddingBottom: 48,
            color: function(LayoutStyle) {
                return LayoutStyle.color ? LayoutStyle.color : theme.palette.common.black;
            },
            background: function(LayoutStyle) {
                return LayoutStyle.backgroundColor ? LayoutStyle.backgroundColor : theme.extraColors.greyMedium;
            }
        }, theme.breakpoints.up('sm'), {}),
        bottomLayout: Footer_defineProperty({
            '&+div': {
                marginTop: theme.spacing(3)
            }
        }, theme.breakpoints.up('lg'), {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center'
        }),
        bottomColumn: Footer_defineProperty({
            '& a': {
                color: function(LayoutStyle) {
                    return LayoutStyle.color && LayoutStyle.color;
                },
                '&:hover, &:focus': {
                    color: function(LayoutStyle) {
                        return LayoutStyle.hover.color && LayoutStyle.hover.color;
                    }
                },
                '&[aria-current=true]': {
                    opacity: 0.5,
                    pointerEvents: 'none'
                },
                '& button': {
                    color: function(LayoutStyle) {
                        return LayoutStyle.color;
                    },
                    borderColor: function(LayoutStyle) {
                        return LayoutStyle.color && LayoutStyle.color;
                    },
                    backgroundColor: function(LayoutStyle) {
                        return LayoutStyle.backgroundColor && LayoutStyle.backgroundColor;
                    },
                    '& .MuiButton-label': {
                        color: function(LayoutStyle) {
                            return LayoutStyle.color && LayoutStyle.color;
                        }
                    },
                    '&:hover, &:focus': {
                        backgroundColor: function(LayoutStyle) {
                            return LayoutStyle.hover.color && LayoutStyle.hover.color;
                        },
                        borderColor: function(LayoutStyle) {
                            return LayoutStyle.hover.color && LayoutStyle.hover.color;
                        }
                    }
                }
            },
            '&>.MuiButton-root': {
                margin: theme.spacing(1)
            },
            '&:nth-child(1)': {
                textAlign: 'center',
                '&>img': Footer_defineProperty({
                    width: 'auto',
                    maxHeight: 100
                }, theme.breakpoints.up('lg'), {
                    marginRight: theme.spacing(3)
                })
            },
            '&:nth-child(2)': {
                textAlign: 'center',
                margin: theme.spacing(0, 0, 2, 0),
                '& a+a': {
                    marginLeft: theme.spacing(2)
                }
            }
        }, theme.breakpoints.up('lg'), {
            flex: '1',
            '&:nth-child(1)': {
                display: 'flex',
                alignItems: 'center'
            },
            '&:nth-child(2)': {
                textAlign: 'right',
                margin: 0
            },
            '&:nth-child(3)': {
                textAlign: 'right'
            },
            '&>.MuiButton-root': {
                margin: theme.spacing(0, 0, 0, 1)
            }
        }),
        bottomTitle: {
            color: function(LayoutStyle) {
                return LayoutStyle.color && LayoutStyle.color;
            }
        },
        social: Footer_defineProperty({
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            margin: theme.spacing(4, 0)
        }, theme.breakpoints.up('lg'), {
            justifyContent: 'flex-start',
            margin: theme.spacing(0)
        }),
        socialItem: {
            margin: theme.spacing(0, 1),
            display: 'inline-block',
            height: 24,
            width: 24,
            objectFit: 'contain',
            '&>img': {
                height: 24,
                width: 24,
                objectFit: 'contain'
            },
            color: function(LayoutStyle) {
                return LayoutStyle.color && LayoutStyle.color;
            }
        },
        logo: {
            width: 'auto',
            maxHeight: 100,
            maxWidth: '100%'
        },
        copyright: {
            textAlign: 'center',
            color: function(LayoutStyle) {
                return LayoutStyle.color ? LayoutStyle.color : theme.palette.common.black;
            },
            background: function(LayoutStyle) {
                return LayoutStyle.backgroundColor ? LayoutStyle.backgroundColor : theme.extraColors.greyMedium;
            },
            padding: theme.spacing(3, 0)
        },
        copyrightText: {
            color: function(LayoutStyle) {
                return LayoutStyle.color ? LayoutStyle.color : theme.palette.common.black;
            },
            '& .paragraph-class': {
                margin: 0
            },
            '& .link-class': {
                color: function(LayoutStyle) {
                    return LayoutStyle.color ? LayoutStyle.color : 'inherit';
                }
            }
        },
        cancelContractRow: Footer_defineProperty({
            textAlign: 'center',
            marginTop: theme.spacing(2)
        }, theme.breakpoints.up('lg'), {
            textAlign: 'right'
        }),
        cancelContractBtn: {
            color: function(LayoutStyle) {
                return LayoutStyle.color && LayoutStyle.color;
            },
            borderColor: function(LayoutStyle) {
                return LayoutStyle.color && LayoutStyle.color;
            }
        }
    });
});
var Footer = function(param) {
    var doc = param.doc, hideTop = param.hideTop, isBG = param.isBG, t = param.t;
    var ref36, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19, ref20, ref21, ref22, ref23, ref24, ref25, ref26, ref27, ref28, ref29, ref30, ref31, ref32;
    var background = doc === null || doc === void 0 ? void 0 : (ref36 = doc.data) === null || ref36 === void 0 ? void 0 : ref36.footer_background;
    var font_color = doc === null || doc === void 0 ? void 0 : (ref1 = doc.data) === null || ref1 === void 0 ? void 0 : ref1.font_color;
    var hover_color = doc === null || doc === void 0 ? void 0 : (ref2 = doc.data) === null || ref2 === void 0 ? void 0 : ref2.hover_color;
    var LayoutStyle = {
        backgroundColor: background,
        color: font_color,
        hover: {
            color: hover_color
        }
    };
    var classes = Footer_useStyles(LayoutStyle);
    var router = (0,next_router.useRouter)();
    var isTopBtn = (0,CMSText/* isPrismicText */.LT)(doc === null || doc === void 0 ? void 0 : (ref3 = doc.data) === null || ref3 === void 0 ? void 0 : ref3.footer_top_link_label);
    var showTopFooter = doc === null || doc === void 0 ? void 0 : (ref4 = doc.data) === null || ref4 === void 0 ? void 0 : ref4.show_footer_top;
    var showCancelContractButton = doc === null || doc === void 0 ? void 0 : (ref5 = doc.data) === null || ref5 === void 0 ? void 0 : ref5.show_cancel_contract_button;
    var trackEvent = (0,useMatomo/* default */.Z)().trackEvent;
    var ref33 = (0,react.useState)(''), registeredStoreSlug = ref33[0], setRegisteredStoreSlug = ref33[1];
    var ref34 = (0,react.useState)(false), isCancelContractOpen = ref34[0], setIsCancelContractOpen = ref34[1];
    (0,react.useEffect)(function() {
        var ref;
        typeof localStorage !== 'undefined' && setRegisteredStoreSlug((ref = JSON.parse(localStorage.getItem('selectedStore'))) === null || ref === void 0 ? void 0 : ref.slug);
    }, [
        typeof localStorage !== 'undefined' && localStorage
    ]);
    var ref35;
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("footer", {
        className: (0,clsx_m/* default */.Z)('footer', classes.root, isBG && classes.isBG),
        children: [
            (doc === null || doc === void 0 ? void 0 : (ref6 = doc.data) === null || ref6 === void 0 ? void 0 : ref6.footer_top_baseline) !== 'undefined' && !hideTop && showTopFooter && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "footer__top ".concat(classes.top),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                    maxWidth: "xl",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
                        container: true,
                        spacing: 3,
                        alignItems: "center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                                item: true,
                                xs: 12,
                                lg: isTopBtn ? 6 : 12,
                                xl: isTopBtn ? 8 : 12,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                    variant: "h5",
                                    component: "div",
                                    className: (0,clsx_m/* default */.Z)(classes.topTitle, 'footer__top__title'),
                                    children: (0,CMSText/* prismicText */.yz)(doc === null || doc === void 0 ? void 0 : (ref7 = doc.data) === null || ref7 === void 0 ? void 0 : ref7.footer_top_baseline, t('texts:general:footer_top_baseline'))
                                })
                            }),
                            isTopBtn && /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                                item: true,
                                xs: 12,
                                lg: 6,
                                xl: 4,
                                className: classes.topRight,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                    variant: "contained",
                                    color: "primary",
                                    onClick: function() {
                                        var ref, ref37;
                                        return trackEvent({
                                            category: "Footer",
                                            href: "/".concat(doc === null || doc === void 0 ? void 0 : (ref = doc.data) === null || ref === void 0 ? void 0 : ref.footer_top_link),
                                            action: "Top link footer to ".concat(doc === null || doc === void 0 ? void 0 : (ref37 = doc.data) === null || ref37 === void 0 ? void 0 : ref37.footer_top_link),
                                            name: "".concat(router.pathname)
                                        });
                                    },
                                    target: (ref8 = doc === null || doc === void 0 ? void 0 : doc.data.footer_top_link) === null || ref8 === void 0 ? void 0 : ref8.target,
                                    href: doc === null || doc === void 0 ? void 0 : (ref9 = doc.data) === null || ref9 === void 0 ? void 0 : (ref10 = ref9.footer_top_link) === null || ref10 === void 0 ? void 0 : ref10.url,
                                    className: "footer__topbtn ".concat(classes.topBtn),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                        asText: true,
                                        data: doc === null || doc === void 0 ? void 0 : (ref11 = doc.data) === null || ref11 === void 0 ? void 0 : ref11.footer_top_link_label,
                                        defaultText: t('texts:general:footer_top_link_label')
                                    })
                                })
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "footer__bottom ".concat(classes.bottom),
                id: "basket_visibility_threshold",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
                    maxWidth: "xl",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "".concat(classes.bottomLayout, " footer__bottomRow1"),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "".concat(classes.bottomColumn, " footer__bottomRow1Col"),
                                    children: [
                                        (doc === null || doc === void 0 ? void 0 : (ref12 = doc.data) === null || ref12 === void 0 ? void 0 : ref12.footer_logo.url) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                            href: (ref35 = doc === null || doc === void 0 ? void 0 : (ref13 = doc.data) === null || ref13 === void 0 ? void 0 : (ref14 = ref13.footer_logo_href) === null || ref14 === void 0 ? void 0 : ref14.url) !== null && ref35 !== void 0 ? ref35 : '/',
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    className: "footer__logo ".concat(classes.logo),
                                                    src: doc === null || doc === void 0 ? void 0 : (ref15 = doc.data) === null || ref15 === void 0 ? void 0 : ref15.footer_logo.url,
                                                    alt: (0,CMSText/* prismicText */.yz)(doc === null || doc === void 0 ? void 0 : (ref16 = doc.data) === null || ref16 === void 0 ? void 0 : ref16.footer_logo.alt, '')
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                            variant: "h4",
                                            component: "div",
                                            className: "footer__baseline ".concat(classes.bottomTitle),
                                            children: (0,CMSText/* prismicText */.yz)(doc === null || doc === void 0 ? void 0 : (ref17 = doc.data) === null || ref17 === void 0 ? void 0 : ref17.footer_tagline, t('texts:general:footer_tagline'))
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "footer__bottomRow1Col ".concat(classes.bottomColumn),
                                    children: [
                                        (0,CMSText/* isPrismicText */.LT)(doc === null || doc === void 0 ? void 0 : (ref18 = doc.data) === null || ref18 === void 0 ? void 0 : (ref19 = ref18.contact_mail) === null || ref19 === void 0 ? void 0 : ref19.url) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                            href: (doc === null || doc === void 0 ? void 0 : (ref20 = doc.data) === null || ref20 === void 0 ? void 0 : (ref21 = ref20.contact_mail) === null || ref21 === void 0 ? void 0 : ref21.url) || '/contact',
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                                    variant: "outlined",
                                                    color: "primary",
                                                    onClick: function() {
                                                        var ref, ref38;
                                                        return trackEvent({
                                                            category: "Footer",
                                                            href: "/".concat(doc === null || doc === void 0 ? void 0 : (ref = doc.data) === null || ref === void 0 ? void 0 : ref.contact_mail.url),
                                                            action: "footer to ".concat(doc === null || doc === void 0 ? void 0 : (ref38 = doc.data) === null || ref38 === void 0 ? void 0 : ref38.contact_mail.url),
                                                            name: "".concat(router.pathname)
                                                        });
                                                    },
                                                    className: (0,clsx_m/* default */.Z)(classes.topBtn, 'footer__contact-btn'),
                                                    children: (0,CMSText/* prismicText */.yz)(doc === null || doc === void 0 ? void 0 : (ref22 = doc.data) === null || ref22 === void 0 ? void 0 : ref22.contact_us_button, t('texts:general:contact_us_button'))
                                                })
                                            })
                                        }),
                                        (doc === null || doc === void 0 ? void 0 : (ref23 = doc.data) === null || ref23 === void 0 ? void 0 : (ref24 = ref23.faq_link) === null || ref24 === void 0 ? void 0 : ref24.url) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                            href: (doc === null || doc === void 0 ? void 0 : (ref25 = doc.data) === null || ref25 === void 0 ? void 0 : (ref26 = ref25.faq_link) === null || ref26 === void 0 ? void 0 : ref26.url) || '/faq',
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                                    variant: "outlined",
                                                    color: "primary",
                                                    onClick: function() {
                                                        return trackEvent({
                                                            category: "Footer",
                                                            href: "/faq",
                                                            action: 'footer to faq',
                                                            name: "".concat(router.pathname)
                                                        });
                                                    },
                                                    className: (0,clsx_m/* default */.Z)(classes.topBtn, 'footer__faq-btn'),
                                                    "aria-current": router.pathname === '/faq',
                                                    disabled: router.pathname === '/faq',
                                                    children: t('texts:general:FAQ')
                                                })
                                            })
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "footer__bottomRow2 ".concat(classes.bottomLayout),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "footer__bottomRow2Col ".concat(classes.bottomColumn),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "footer__social ".concat(classes.social),
                                        children: doc === null || doc === void 0 ? void 0 : (ref27 = doc.data) === null || ref27 === void 0 ? void 0 : ref27.social_networks.map(function(socialNetwork, index) {
                                            /*#__PURE__*/ return (0,jsx_runtime.jsx)("a", {
                                                href: socialNetwork.link.url,
                                                target: "_blank",
                                                onClick: function() {
                                                    return trackEvent({
                                                        category: 'Footer',
                                                        href: "/".concat(socialNetwork.link.url),
                                                        action: "footer to ".concat(socialNetwork.link.url),
                                                        name: "".concat(router.pathname)
                                                    });
                                                },
                                                rel: "noopener noreferrer",
                                                className: classes.socialItem,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    src: socialNetwork.icon.url,
                                                    alt: (0,CMSText/* prismicText */.yz)(socialNetwork === null || socialNetwork === void 0 ? void 0 : socialNetwork.label)
                                                })
                                            }, index);
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (0,clsx_m/* default */.Z)('footer__bottomRow2Col', 'footer__menu', classes.bottomColumn),
                                    children: [
                                        typeof tC !== 'undefined' && "object" !== 'undefined' && /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                            href: '#',
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                target: '_self',
                                                onClick: function() {
                                                    var ref;
                                                    return tC === null || tC === void 0 ? void 0 : (ref = tC.privacyCenter) === null || ref === void 0 ? void 0 : ref.showPrivacyCenter();
                                                },
                                                children: t('texts:general:handle_cookies')
                                            })
                                        }),
                                        (doc === null || doc === void 0 ? void 0 : (ref28 = doc.data) === null || ref28 === void 0 ? void 0 : ref28.footer_menu.length) !== 0 && (doc === null || doc === void 0 ? void 0 : (ref29 = doc.data) === null || ref29 === void 0 ? void 0 : ref29.footer_menu.map(function(item, index) {
                                            var ref, ref39;
                                            var itemType = (item === null || item === void 0 ? void 0 : (ref = item.link) === null || ref === void 0 ? void 0 : ref.uid) !== undefined;
                                            var itemSrc = itemType ? "/pages/".concat(item.link.uid) : item.link.url;
                                            var itemUrl = ((itemSrc === null || itemSrc === void 0 ? void 0 : itemSrc.includes('cgl')) || (itemSrc === null || itemSrc === void 0 ? void 0 : itemSrc.includes('mentions-legales'))) && typeof registeredStoreSlug !== 'undefined' && registeredStoreSlug !== '' && registeredStoreSlug !== null ? "".concat(itemSrc, "-").concat(registeredStoreSlug) : "".concat(itemSrc);
                                            return itemType ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                                href: itemUrl,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    id: "footer-link-".concat(index),
                                                    onClick: function() {
                                                        return trackEvent({
                                                            category: "Footer",
                                                            href: itemUrl,
                                                            action: "Link to ".concat(itemUrl),
                                                            name: "".concat(router.pathname)
                                                        });
                                                    },
                                                    "aria-current": router.asPath !== null && router.asPath === itemUrl,
                                                    children: (0,CMSText/* prismicText */.yz)(item === null || item === void 0 ? void 0 : item.label)
                                                })
                                            }, index) : item.link.url && /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                                href: itemUrl,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    target: ((ref39 = item.link) === null || ref39 === void 0 ? void 0 : ref39.target) === '_blank' ? '_blank' : '_self',
                                                    onClick: function() {
                                                        return trackEvent({
                                                            category: "Footer",
                                                            href: itemUrl,
                                                            action: "Link to ".concat(itemUrl),
                                                            name: "".concat(router.pathname)
                                                        });
                                                    },
                                                    "aria-current": router.asPath !== null && router.asPath === itemUrl,
                                                    children: (0,CMSText/* prismicText */.yz)(item === null || item === void 0 ? void 0 : item.label)
                                                })
                                            }, index);
                                        }))
                                    ]
                                })
                            ]
                        }),
                        showCancelContractButton && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "footer__cancelContract ".concat(classes.cancelContractRow),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                variant: "outlined",
                                color: "primary",
                                className: (0,clsx_m/* default */.Z)('footer__cancel-contract-btn', classes.cancelContractBtn),
                                onClick: function() {
                                    trackEvent({
                                        category: "Footer",
                                        action: "Open cancel my contract modal",
                                        name: "".concat(router.pathname)
                                    });
                                    setIsCancelContractOpen(true);
                                },
                                children: (0,CMSText/* prismicText */.yz)(doc === null || doc === void 0 ? void 0 : (ref30 = doc.data) === null || ref30 === void 0 ? void 0 : ref30.cancel_contract_button_label, t('texts:cancel_contract:button_label'))
                            })
                        })
                    ]
                })
            }),
            showCancelContractButton && /*#__PURE__*/ (0,jsx_runtime.jsx)(ContactRequest_CancelContractModal, {
                open: isCancelContractOpen,
                onClose: function() {
                    return setIsCancelContractOpen(false);
                },
                doc: doc,
                t: t
            }),
            (0,CMSText/* isPrismicText */.LT)(doc === null || doc === void 0 ? void 0 : (ref31 = doc.data) === null || ref31 === void 0 ? void 0 : ref31.copyright) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "footer__copyright ".concat(classes.copyright),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                    maxWidth: "xl",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        component: 'div',
                        className: "footer-copyright__text ".concat(classes.copyrightText),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                            defaultText: t('texts:general:copyright'),
                            data: doc === null || doc === void 0 ? void 0 : (ref32 = doc.data) === null || ref32 === void 0 ? void 0 : ref32.copyright
                        })
                    })
                })
            })
        ]
    }));
};
/* harmony default export */ var Layout_Footer = (Footer);


/***/ })

}]);